import { useEffect, useState } from "react"
import { Step } from "../../components/Step/ResultsStep"
import { competition } from "../../services/resultsService";
import { Competition } from "../../components/Widgets/Competition";

export const ResultsCompetition = () => {
    const [content, setContent] = useState({
        competition: {
            attributes: [],
            labels: ["Your Company Now", "Your Aim"],
            datasets: [
                {
                    backgroundColor: ["white", "#FCE816"],
                    borderColor: ["white", "transparent"],
                    data: [
                        {
                            x: 3,
                            y: 0,
                        },
                        {
                            x: 4,
                            y: 5,
                        },
                    ],
                },
            ],
        },
        paragraph: 'Content is being loaded'
    });

    const [companyName, setCompanyName] = useState("Your Company");

    const header = {
        index: "08",
        section: "Relationships - Competition",
        company: companyName
    }

    useEffect(() => {
        competition().then(response => {
            const { company, competition } = response.data;
            const values = JSON.parse(competition).competition[0];
            const len = (values.positions.length || values.labels.length) - 2;
            
            if (competition) {
                setContent({
                    ...content, competition: {
                        attributes: values.attributes,
                        labels: values.labels,
                        datasets: [
                            {
                                backgroundColor: ["white", "#FCE816", ...Array(len)].fill("red", 2),
                                borderColor: ["white", "#FCE816", ...Array(len)].fill("red", 2),
                                data: [...values.positions]
                            }
                        ]
                    }
                });
            }
            company ? setCompanyName(company) : setCompanyName('Your Company');
        }).catch(err => {
            console.error(err);
        })
    }, []);
    return (
        <Step header={header}>
            <section className="grid gap-0 items-center pt-4 pb-4">
                <span className="h-auto top border-b border-dark-grey ">{content.competition.attributes[1]}</span>
                <span className="left border-b border-dark-grey">{content.competition.attributes[0]}</span>
                <div className="center">
                    <Competition data={content.competition} color="white"/>
                </div>
                <span className="right border-b border-dark-grey">{content.competition.attributes[2]}</span>
                <span className="bottom border-b border-dark-grey">{content.competition.attributes[3]}</span>
            </section>
            {/* <p className="results__description">
                {content.paragraph}
            </p> */}
        </Step>
    )
}